const MeetingType = props => {
    const type1 = props.row['devTags.MeetingTypeOption1'];
    const type2 = props.row['devTags.MeetingTypeOption2'];
    const value = props.row['devTags.MeetingType'] === 'Yes' ? type1 : type2;

    return value ? value : null;
};

export default MeetingType;
